// extracted by mini-css-extract-plugin
module.exports = {"scorecard":"Scorecard_scorecard__2wtW8","rank":"Scorecard_rank__cjrv0","label":"Scorecard_label__3DBoF","flexbreak":"Scorecard_flexbreak__3wFhi"};